module.exports = __webpack_public_path__ + "static/media/YouTube_400.63623cd0.jpg";